import e from "../common/html_blocks.js";
import { HTML_OPEN_CLOSE_TAG_RE as r } from "../common/html_re.js";
new RegExp("^</?(" + e.join("|") + ")(?=(\\s|/?>|$))", "i"), new RegExp(r.source + "\\s*$");
